import { PayloadAction, createReducer } from '@reduxjs/toolkit';
import { initialState } from '@modules/orders-and-trips/store';
import { getDepotRoutine } from '@modules/orders-and-trips/actions';
import { onFailure } from '@common/utils/helpers/reducers';
import { DepotShort } from '@common/types/dictionaries/depot';
import { InitialState } from '../types/general';

export const getDepotReducer = createReducer(initialState, {
  [getDepotRoutine.REQUEST]: (state: InitialState) => {
    state.extraData.isFetching = true;
    return state;
  },
  [getDepotRoutine.SUCCESS]: (
    state: InitialState,
    action: PayloadAction<{
      data: DepotShort;
    }>
  ) => {
    const { data } = action.payload;
    state.extraData.depot = data;
    return state;
  },
  [getDepotRoutine.FAILURE]: onFailure,
  [getDepotRoutine.FULFILL]: (state: InitialState) => {
    state.error = [];
    state.extraData.isFetching = false;
    return state;
  }
});
